import QuotationAmounts from './QuotationAmounts';

/**
 * Class representing additional quotation amounts.
 */
class AdditionalQuotationAmounts extends QuotationAmounts {
  fromQuotations(quotations) {
    const { taxes, subtotal, total } = quotations.reduce(
      (totals, quotation) => ({
        taxes: totals.taxes + quotation.taxesAmount,
        subtotal: totals.subtotal + quotation.subtotal,
        total: totals.total + quotation.totalAmount,
      }),
      { taxes: 0, subtotal: 0, total: 0 },
    );

    this.taxes = taxes.toFixed(2);
    this.subtotal = subtotal.toFixed(2);
    this.total = total.toFixed(2);

    return this;
  }
}

export default AdditionalQuotationAmounts;
